module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kiwi-messageinfo",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "kiwi-messageinfo-author"
  }, [_c('a', {
    staticClass: "u-link",
    on: {
      "click": _vm.openQuery
    }
  }, [_vm._v("Reply in private")])]), _vm._v(" "), (_vm.areWeAnOp()) ? _c('div', {
    staticClass: "kiwi-messageinfo-opactions"
  }, [_c('input-prompt', {
    attrs: {
      "label": "Kick reason:"
    },
    on: {
      "submit": _vm.onKick
    }
  }, [_c('a', {
    staticClass: "u-link"
  }, [_vm._v("Kick " + _vm._s(_vm.message.nick))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input-prompt', {
    attrs: {
      "label": "Ban reason:"
    },
    on: {
      "submit": _vm.onBan
    }
  }, [_c('a', {
    staticClass: "u-link"
  }, [_vm._v("Ban " + _vm._s(_vm.message.nick))])])], 1) : _vm._e(), _vm._v(" "), (_vm.message.mentioned_urls.length > 0) ? _c('div', {
    staticClass: "kiwi-messageinfo-urls"
  }, _vm._l((_vm.message.mentioned_urls), function(url) {
    return _c('div', {
      staticClass: "kiwi-messageinfo-url"
    }, [_c('a', {
      staticClass: "u-button u-button-secondary",
      on: {
        "click": function($event) {
          _vm.urlPreview(url)
        }
      }
    }, [_vm._v("Preview")]), _vm._v(" "), _c('a', {
      staticClass: "u-link",
      attrs: {
        "href": url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(url))])])
  })) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "fa fa-caret-up kiwi-messageinfo-close",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6a66e3da!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MessageInfo.vue
// module id = 493
// module chunks = 2